import React, { useContext, useState } from 'react'
import { Container, Nav, Navbar, Offcanvas } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { HrStorage } from '../../Context/HrStore'
import FacebookIcon from '../../SVG/FacebookIcon'
import TwitterIcon from '../../SVG/TwitterIcon'
import InstagramIcon from '../../SVG/InstagramIcon'
import LinkedInIcon from '../../SVG/LinkedInIcon'

const HomeNavBar = ({ type }) => {
    let [show, setshow] = useState(false)
    let { active, setactive } = useContext(HrStorage)

    let navigate = useNavigate()

    const handleNavigation = (path, currentActive) => {
        setactive(currentActive);
        navigate(path);
        setshow(false); // Always close mobile menu on click
    };

    return (
        <div>
            <Navbar key="lg" expand="lg" className="xl:min-h-[12vh] py-2 lg:py-0 w-full z-50">
                <Container>
                    <Navbar.Brand href="/" className=''>
                        {type == 'white' ?
                            <img className='w-[120px] lg:ms-5' src={require("../../Assest/cards/MeridaConsultancyLogo.avif")} alt="logo" />
                            : <img className='w-[120px] lg:ms-5' src={require("../../Assest/cards/MeridaConsultancyLogo.avif")}
                                alt="logo" />}
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={() => setshow(true)} className={`${type == 'white' && 'bg-white'} `}
                        aria-controls={`offcanvasNavbar-expand-"lg"`} />
                    <Navbar.Offcanvas
                        show={show}
                        onHide={() => setshow(false)}
                        id={`offcanvasNavbar-expand-"lg"`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-"lg"`}
                        placement="end"
                        className="transi">
                        <Offcanvas.Header className='flex justify-between'>
                            <img onClick={() => handleNavigation("/", "home")} className='w-[150px] cursor-pointer' src={require("../../Assest/cards/MeridaConsultancyLogo.avif")} alt="logo" />
                            <img onClick={() => setshow(false)} className='w-[20px] cursor-pointer' src={require("../../Assest/cards/close.avif")} alt="close" />
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className={`${type == 'white' && ' lg:text-slate-50'} lg:justify-between h-full flex-grow-1 lg:items-center lg:ms-8`}>
                                <div className='flex flex-col lg:flex-row flex-1 lg:justify-center lg:items-center transi urban gap-4 lg:gap-6 xl:gap-8 fw-medium text-base lg:text-[15px] xl:text-base mt-4 lg:mt-0'>
                                    <Nav.Link onClick={() => handleNavigation("/", "home")}>
                                        <p className={`${active == 'home' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            Home 
                                        </p>
                                    </Nav.Link>

                                    <Nav.Link onClick={() => handleNavigation("/about", "about")}>
                                        <p className={`${active == 'about' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            About us 
                                        </p>
                                    </Nav.Link>
                                    
                                    <Nav.Link onClick={() => handleNavigation("/why-merida", "why-merida")}>
                                        <p className={`${active == 'why-merida' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            Why Merida HR 
                                        </p>
                                    </Nav.Link>
                                    
                                    <Nav.Link onClick={() => handleNavigation("/service", "service")}>
                                        <p className={`${active == 'service' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            Our Services 
                                        </p>
                                    </Nav.Link>

                                    <Nav.Link onClick={() => handleNavigation("/industry", "industry")}>
                                        <p className={`${active == 'industry' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            Industry 
                                        </p>
                                    </Nav.Link>

                                    <Nav.Link onClick={() => handleNavigation("/blogs", "blog")}>
                                        <p className={`${active == 'blog' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            Blog 
                                        </p>
                                    </Nav.Link>

                                    <Nav.Link onClick={() => handleNavigation("/careers", "career")}>
                                        <p className={`${active == 'career' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            Careers 
                                        </p>
                                    </Nav.Link>

                                    <Nav.Link onClick={() => handleNavigation("/contact", "contact")}>
                                        <p className={`${active == 'contact' && 'border-b-2 border-blue-900'} m-0 w-fit ${type == 'white' && 'lg:text-slate-50'} fw-light hover:text-blue-600 transition-colors whitespace-nowrap`}>
                                            Contact 
                                        </p>
                                    </Nav.Link>

                                </div>
                                {/* Icons */}
                                <section className='flex gap-4 relative flex-wrap my-6 lg:my-0' >
                                    <a className={`cursor-pointer ${type == 'white' ? 'text-white' : 'text-slate-800'} hover:text-blue-600 transition-colors`} ><FacebookIcon size={18} /> </a>
                                    <a className={`cursor-pointer ${type == 'white' ? 'text-white' : 'text-slate-800'} hover:text-blue-600 transition-colors`}><TwitterIcon size={18} /> </a>
                                    <a className={`cursor-pointer ${type == 'white' ? 'text-white' : 'text-slate-800'} hover:text-blue-600 transition-colors`}><InstagramIcon size={18} /> </a>
                                    <a className={`cursor-pointer ${type == 'white' ? 'text-white' : 'text-slate-800'} hover:text-blue-600 transition-colors`}><LinkedInIcon size={18} /> </a>
                                </section>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </div>
    )
}

export default HomeNavBar